var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCheckInCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 47 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ic-check-in-circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 4.25c8.685 0 15.75 7.065 15.75 15.75S28.685 35.75 20 35.75 4.25 28.685 4.25 20 11.315 4.25 20 4.25M20 2C10.055 2 2 10.055 2 20s8.055 18 18 18 18-8.055 18-18S29.945 2 20 2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.366 25.055c-.285 0-.57-.105-.796-.33l-4.59-4.59a1.13 1.13 0 0 1 0-1.59 1.13 1.13 0 0 1 1.59 0l3.796 3.795 7.064-7.065a1.13 1.13 0 0 1 1.59 0 1.13 1.13 0 0 1 0 1.59l-7.86 7.86c-.224.225-.51.33-.794.33"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ic-check-in-circle_svg__a",
  width: 44,
  height: 44,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.823529 0 0 0 0 0.882353 0 0 0 0 0.886275 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_997_65462"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_997_65462",
  result: "shape"
})))));
export default SvgIcCheckInCircle;